import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { IconButton } from '../material-ui/IconButton';
import { List, ListItemSecondaryAction, ListItemText, ListSubheader } from '../material-ui/List';
import { DownloadAll } from '../../icons';
import { CrewTypes } from '../../service/constants';
import { useAttachmentsPage } from './useAttachmentsPage';
import { ContentType } from './constants';
import { useStyles } from './useStyles';

export const AttachmentsPage = memo(() => {
    const { Component, contentType, crewType, currentLegInfo, attachmentWithWarning, plnName, title, handleDowloadAllClick } =
        useAttachmentsPage();
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <List className={classNames('menu-list', classes.list)} component="div" disablePadding={true}>
            {crewType === CrewTypes.PCT_CABINSTAFF || crewType === CrewTypes.PCT_SALONSTAFF ? (
                <>
                    <ListSubheader classes={{ root: classes.listSubheader }}>
                        <ListItemText
                            primary={
                                <>
                                    {translate(title)} {currentLegInfo}
                                    {contentType === ContentType.LIMITATIONS && (
                                        <span className={classes.bold}>{(plnName && ` ${plnName.toUpperCase()}`) || ''}</span>
                                    )}
                                </>
                            }
                        />
                        {attachmentWithWarning.length > 0 && (
                            <ListItemSecondaryAction className={classes.menu}>
                                <IconButton className={classes.icon} onClick={handleDowloadAllClick}>
                                    <DownloadAll width="24" height="24" />
                                </IconButton>
                            </ListItemSecondaryAction>
                        )}
                    </ListSubheader>
                    {Component && <Component />}
                </>
            ) : (
                <ListItemText primary={translate('messages.noAvailableInfoForLeg')} />
            )}
        </List>
    );
});

AttachmentsPage.displayName = 'AttachmentsPage';
